var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    d: "M6.79018 10.54C3.33978 10.54 0.392578 11.084 0.392578 13.26C0.392578 15.4368 3.32138 16 6.79018 16C10.2406 16 13.1878 15.4568 13.1878 13.28C13.1878 11.1032 10.2598 10.54 6.79018 10.54Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    d: "M6.79024 8.4672C9.14064 8.4672 11.0238 6.5832 11.0238 4.2336C11.0238 1.884 9.14064 0 6.79024 0C4.44064 0 2.55664 1.884 2.55664 4.2336C2.55664 6.5832 4.44064 8.4672 6.79024 8.4672Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.3531828ad100653281ee3245791c68e9.svg";
export { ForwardRef as ReactComponent };